import React from 'react'
import { connect } from 'react-redux'

import PageHeader from '../components/PageHeader'
import PageSection from '../components/PageSection'
import Button from '../components/Button'

import ContactForm from '../components/ContactForm'
import SocialButton from '../components/SocialButton'
import EnterpriseContactModal from '../components/EnterpriseContactModal'

import { showModal } from '../../reducers/modal'
import { trackEvent } from '../../utils/tracking'

import {
  DISCORD_LINK,
  FACEBOOK_LINK,
  TWITTER_LINK,
  LINKEDIN_LINK,
  INSTAGRAM_LINK
} from '../../config'

const FOLLOW_LINKS = [
  {
    name: 'twitter',
    url: TWITTER_LINK,
    icon: 'twitter'
  },
  {
    name: 'facebook',
    url: FACEBOOK_LINK,
    icon: 'facebook-square'
  },
  {
    name: 'linkedin',
    url: LINKEDIN_LINK,
    icon: 'linkedin-square'
  },
  {
    name: 'instagram',
    url: INSTAGRAM_LINK,
    icon: 'instagram'
  },
  {
    name: 'community',
    url: DISCORD_LINK,
    icon: 'discord-square'
  }
]

export const ContactPage = ({
  data: { acf: { headerTitle, introContent } },
  showModal
}) => (
  <main className='main contact-page maxw-xxlarge mx-auto'>
    <PageHeader extraClass='js-dark-section' title={headerTitle}>
      <div
        className='text-para'
        dangerouslySetInnerHTML={{ __html: introContent }}
      />
    </PageHeader>

    <PageSection extraClass='page-section--tiny center bg-white mx-auto'>
      <div className='maxw-large mx-auto'>
        <ContactForm />
      </div>
    </PageSection>

    <PageSection extraClass='contact-page__social-section page-section--small bg-white'>
      <div className='bold center mb2'>Find Us on Social Networks</div>
      <div className='contact-page__follow-links flex flex-wrap justify-center items-center'>
        {FOLLOW_LINKS.map(({ name, url, icon }) => (
          <SocialButton
            url={url}
            key={name}
            icon={icon}
            forceAnchorElement
            target='_blank'
            extraClass={`social-button--${name} flex items-center mx2 mb2`}
          >
            <span className='bold ml1 capitalize xs-hide'>{name}</span>
          </SocialButton>
        ))}
      </div>
    </PageSection>

    <PageSection extraClass='contact-page__enterprise-section'>
      <div className='bg-white center col-11 maxw-medium mx-auto py4 px2'>
        <h2 className='h3 mb2'>Enterprise client?</h2>
        <p className='mb3 maxw-small mx-auto'>
          Let’s discuss how Snips can accomodate your needs and your platform
        </p>
        <Button
          className='button button--secondary'
          onClick={() => {
            showModal(<EnterpriseContactModal />)
            trackEvent('EnterpriseContactModal', 'ContactPageBottom')
          }}
        >
          Contact our enterprise team
        </Button>
      </div>
    </PageSection>
  </main>
)

export default connect(null, { showModal })(ContactPage)



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/ContactPage.js